function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { normalizeEncoding } from '../encoding';
import * as log from '../log';
import { CompositeMarkNormalizer } from './base';
import { makeCompositeAggregatePartFactory } from './common';
import { errorBarParams } from './errorbar';
export var ERRORBAND = 'errorband';
export var ERRORBAND_PARTS = ['band', 'borders'];
export var errorBandNormalizer = new CompositeMarkNormalizer(ERRORBAND, normalizeErrorBand);
export function normalizeErrorBand(spec, _ref) {
  var config = _ref.config;
  // Need to initEncoding first so we can infer type
  spec = _objectSpread(_objectSpread({}, spec), {}, {
    encoding: normalizeEncoding(spec.encoding, config)
  });

  var _errorBarParams = errorBarParams(spec, ERRORBAND, config),
      transform = _errorBarParams.transform,
      continuousAxisChannelDef = _errorBarParams.continuousAxisChannelDef,
      continuousAxis = _errorBarParams.continuousAxis,
      encodingWithoutContinuousAxis = _errorBarParams.encodingWithoutContinuousAxis,
      markDef = _errorBarParams.markDef,
      outerSpec = _errorBarParams.outerSpec,
      tooltipEncoding = _errorBarParams.tooltipEncoding;

  var errorBandDef = markDef;
  var makeErrorBandPart = makeCompositeAggregatePartFactory(errorBandDef, continuousAxis, continuousAxisChannelDef, encodingWithoutContinuousAxis, config.errorband);
  var is2D = spec.encoding.x !== undefined && spec.encoding.y !== undefined;
  var bandMark = {
    type: is2D ? 'area' : 'rect'
  };
  var bordersMark = {
    type: is2D ? 'line' : 'rule'
  };

  var interpolate = _objectSpread(_objectSpread({}, errorBandDef.interpolate ? {
    interpolate: errorBandDef.interpolate
  } : {}), errorBandDef.tension && errorBandDef.interpolate ? {
    tension: errorBandDef.tension
  } : {});

  if (is2D) {
    bandMark = _objectSpread(_objectSpread(_objectSpread({}, bandMark), interpolate), {}, {
      ariaRoleDescription: 'errorband'
    });
    bordersMark = _objectSpread(_objectSpread(_objectSpread({}, bordersMark), interpolate), {}, {
      aria: false
    });
  } else if (errorBandDef.interpolate) {
    log.warn(log.message.errorBand1DNotSupport('interpolate'));
  } else if (errorBandDef.tension) {
    log.warn(log.message.errorBand1DNotSupport('tension'));
  }

  return _objectSpread(_objectSpread({}, outerSpec), {}, {
    transform: transform,
    layer: [].concat(_toConsumableArray(makeErrorBandPart({
      partName: 'band',
      mark: bandMark,
      positionPrefix: 'lower',
      endPositionPrefix: 'upper',
      extraEncoding: tooltipEncoding
    })), _toConsumableArray(makeErrorBandPart({
      partName: 'borders',
      mark: bordersMark,
      positionPrefix: 'lower',
      extraEncoding: tooltipEncoding
    })), _toConsumableArray(makeErrorBandPart({
      partName: 'borders',
      mark: bordersMark,
      positionPrefix: 'upper',
      extraEncoding: tooltipEncoding
    })))
  });
}